module.exports = __webpack_public_path__ + "static/media/straighten_08.e0c018f3.png";